import { render } from "./Clover.vue?vue&type=template&id=3461ef85&ts=true"
import script from "./Clover.vue?vue&type=script&lang=ts"
export * from "./Clover.vue?vue&type=script&lang=ts"

import "./Clover.vue?vue&type=style&index=0&id=3461ef85&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__